import {Slide} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {useStyles} from '@webapps/styles';
import PropTypes from 'prop-types';
import {createContext, useContext, useEffect, useState} from 'react';

const ToastContextNoAutoDelete = createContext();

const ToastProviderNoAutoDelete = ({
  autoDelete = false,
  children,
  dismissTime = 5000,
}) => {
  const [list, setList] = useState([]);

  const {classes} = useStyles(styles);

  const deleteToast = (deletedId) =>
    setList(list.filter(({id}) => id !== deletedId));

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && list.length && list.length) {
        deleteToast(list?.[0]?.id);
      }
    }, dismissTime);

    return () => {
      clearInterval(interval);
    };
  }, [list, autoDelete, dismissTime, deleteToast]);

  const addToast = (toast) => {
    const newIndex = (list[list.length - 1]?.id || 0) + 1;
    const newToast = {...toast, id: newIndex};

    setList(
      list.length > 2 ? [...list.slice(0, 2), newToast] : [...list, newToast]
    );
  };

  return (
    <ToastContextNoAutoDelete.Provider value={{list, setList, addToast}}>
      <div className={classes.notificationContainer}>
        {list.map(({id, message, status}) => (
          <Slide key={id} direction="up" in mountOnEnter unmountOnExit>
            <Alert
              className={classes.notification}
              onClose={() => deleteToast(id)}
              severity={status}
              variant="filled"
            >
              {message}
            </Alert>
          </Slide>
        ))}
      </div>
      {children}
    </ToastContextNoAutoDelete.Provider>
  );
};

const styles = ({fontSizes}) => ({
  notificationContainer: {
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    boxSizing: 'border-box',
    position: 'fixed',
    left: '50%',
    zIndex: 10000,
    bottom: 10,
    // right: 10,
  },
  notification: {
    marginBottom: 10,
  },
});

ToastProviderNoAutoDelete.propTypes = {
  children: PropTypes.node,
  autoDelete: PropTypes.bool,
  dismissTime: PropTypes.number,
};

export const useToastNoAutoDelete = () => {
  const {addToast, list, setList} = useContext(ToastContextNoAutoDelete);
  return {list, setList, addToast};
};

export default ToastProviderNoAutoDelete;
